<template>
  <div>
    <scrollTop>
      <i class="icon-fa icon-fa-arrow-up"></i>
    </scrollTop>
    <table class="table table-striped table-hover table-sm">
      <thead>
      <tr>
        <th></th>
        <th></th>
        <th>Тип</th>
        <th>ID</th>
        <th>Дата</th>
        <th>Откуда/куда</th>
        <th>Дт</th>
        <th>Кр</th>
        <th>Итог</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(record, timestamp, i) in data" v-bind:class="{
        'tr_red': remain[timestamp] && remain[timestamp].remain < 0,
        'tr_green': remain[timestamp] && remain[timestamp].remain === 0,
      }">
        <td>{{ i + 1 }}</td>
        <template v-if="record.type === 'order'">
          <td></td>
          <td>{{ record.data.type_id === 2 ? 'Возврат' : 'Продажа' }}</td>
          <td>
            {{ record.data.id }}
            <button
              @click="orderToEdit(record.data.id)"
              class="btn btn-xs btn-info pull-left mr-2"
            >
              <i class="icon-fa icon-fa-eye"></i>
            </button>
          </td>
          <td>{{ record.date }}</td>
          <td>{{ !storeId ? $AllCities[record.data.city_id].name : null }}</td>
          <td></td>
          <td>{{ remain[timestamp] && remain[timestamp].qty || 0 }}</td>
        </template>
        <template v-else>
          <td>
            <i v-if="getTitleByRecord(record).in" @click="showInvoice(record.data.id)"
               class="icon-fa icon-fa-plus-square pointer click"></i>
            <i v-else @click="showInvoice(record.data.id)" class="icon-fa icon-fa-minus-square pointer click"></i>
          </td>
          <td>{{ getTitleByRecord(record).title }}</td>
          <td>{{ record.data.id }}</td>
          <td>{{ record.date }}</td>
          <td>{{
              record.data.store_in === +storeId ?
                $AllStores[record.data.store_out] && $AllStores[record.data.store_out].title || record.data.store_out :
                $AllStores[record.data.store_in] && $AllStores[record.data.store_in].title || record.data.store_in
            }}
          </td>
          <td>{{
              record.data.store_in === +storeId || record.data.store_out === null ? remain[timestamp] && remain[timestamp].qty || 0 : null
            }}
          </td>
          <td>{{
              record.data.store_out === +storeId || record.data.store_in === 1 ? remain[timestamp] && remain[timestamp].qty || 0 : null
            }}
          </td>
        </template>
        <td>{{ remain[timestamp] && remain[timestamp].remain || 0 }}</td>
      </tr>
      </tbody>
    </table>
    <h5>Итого: <strong>{{ totalRemain }}</strong></h5>
  </div>
</template>
<script>

import scrollTop from "../../components/scrollTop";

export default {
  props: ['data', 'inStore', 'storeId'],
  components: {
    scrollTop,
  },
  data() {
    return {
      remain: {},
      totalRemain: 0,
    }
  },
  computed: {
    $AllStores() {
      return this.$store.getters['platform/stores'];
    },
    $AllCities() {
      let cities = this.$store.getters["platform/cities"];
      cities[0] = {id: 0, name: "Почтовые города", short_name: "Почта"};
      return cities;
    },
  },
  mounted() {
    this.updateRemainQty()
  },
  methods: {
    orderToEdit(id) {
      this.$store.dispatch('orders/setOrderToEdit', {orderId: id});
    },
    showInvoice(id) {
      this.$store.dispatch('invoices/setInvoiceToEdit', {invoiceId: id});
    },
    updateRemainQty() {
      let inStore = this.inStore;
      this.remain = Object.keys(this.data).reduce((acc, t) => {
        let qty = 0;
        if (this.data[t].type === 'order') {
          if (this.data[t].data.type_id === 2) {
            qty += +Math.abs(this.data[t].qty);
          } else {
            qty -= +this.data[t].qty;
          }
        } else {
          if (this.data[t].data.store_out === 3 && this.data[t].data.store_in === 3) {
            acc[t] = {qty: qty, remain: inStore};
            return acc;
          }
          if (this.data[t].data.store_out === +this.storeId || this.data[t].data.store_in === 1) {
            qty -= +this.data[t].qty;
          } else {
            qty += +this.data[t].qty;
          }
        }
        inStore += qty;
        if (this.data[t].type === 'order') {
          qty *= -1;
        }
        acc[t] = {qty: qty, remain: Math.round(inStore * 100) / 100};
        return acc;
      }, {});
      this.totalRemain = Math.round(inStore * 100) / 100;
      // this.remain = {...this.remain};
    },
    getTitleByRecord(record) {
      const data = {title: null, in: false};
      if (record.type === 'invoice') {
        if (record.data.type_id === 1 || record.data.store_in === +this.storeId) {
          data.title = 'Приход';
          data.in = true;
        } else {
          data.title = 'Расход';
          data.in = false;
        }
      }
      return data;
    }
  }
}
</script>

<style scoped>
.btn-xs {
  padding: 0px 5px !important;
}

.tr_red {
  background-color: #ffd7d7 !important;
}

.tr_green {
  background-color: #bdf8bd !important;
}

.pointer.click:hover {
  color: #5BBFDE;
}
</style>
